import { ITchatRoom } from './interface/tchat-room.interface';
import { ITchatUser } from './interface/tchat-user.interface';
import { TchatMessage } from './tchat-message';
import { TchatUser } from './tchat-user';

export class TchatRoom implements ITchatRoom {
    guid: string;
    organizationId: string;
    messages: TchatMessage[];
    notifications: number;

    public target: ITchatUser;

    constructor(public users: TchatUser[]) {
        this.messages = [];
        this.notifications = 0;
    }

    public static createFormCopy(chatRoom: ITchatRoom): TchatRoom {
        const instance = new TchatRoom(chatRoom.users);
        instance.guid = chatRoom.guid;
        instance.organizationId = chatRoom.organizationId;
        instance.messages = chatRoom.messages.map((m) => TchatMessage.createFormCopy(m));
        instance.notifications = chatRoom.notifications;
        return instance;
    }
}
